import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import Swal from "sweetalert2";

import { db } from "../../firebase";

import {
    collection,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    onSnapshot,
    Timestamp
} from "firebase/firestore";

function Rfferancedetails   () {

    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");

    const [open, setOpen] = useState(false);
    const [editId, setEditId] = useState(null);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        address: "",
        joiningDate: ""
    });

    // ================= LOAD DATA =================

    useEffect(() => {

        const unsub = onSnapshot(
            collection(db, "throughdetails"),
            (snapshot) => {

                const list = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setData(list);

            }
        );

        return () => unsub();

    }, []);
    const handleSave = async () => {
        try {
            if (!formData.name) {
                return Swal.fire(
                    "Error",
                    "Name required",
                    "error"
                );
            }

            if (editId) {

                await updateDoc(
                    doc(db, "throughdetails", editId),
                    {
                        ...formData
                    }
                );

                Swal.fire(
                    "Updated",
                    "Record updated successfully",
                    "success"
                );

            } else {

                await addDoc(
                    collection(db, "throughdetails"),
                    {
                        ...formData,
                        createdAt: Timestamp.now()
                    }
                );

                Swal.fire(
                    "Success",
                    "Record added successfully",
                    "success"
                );
            }

            handleClose();

        } catch (err) {

            Swal.fire(
                "Error",
                err.message,
                "error"
            );

        }

    };

    // ================= EDIT =================

    const handleEdit = (row) => {

        setEditId(row.id);

        setFormData({
            name: row.name || "",
            mobile: row.mobile || "",
            address: row.address || "",
            joiningDate: row.joiningDate || ""
        });

        setOpen(true);

    };

    // ================= DELETE =================

    const handleDelete = async (id) => {

        const result = await Swal.fire({
            title: "Delete Record?",
            text: "This record will be permanently deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33"
        });

        if (!result.isConfirmed) return;

        try {

            await deleteDoc(
                doc(db, "throughdetails", id)
            );

            Swal.fire(
                "Deleted",
                "Record deleted successfully",
                "success"
            );

        } catch (err) {

            Swal.fire(
                "Error",
                err.message,
                "error"
            );

        }

    };

    // ================= RESET =================

    const handleClose = () => {

        setOpen(false);

        setEditId(null);

        setFormData({
            name: "",
            mobile: "",
            address: "",
            joiningDate: new Date()
                .toISOString()
                .split("T")[0]
        });

    };

    // ================= SEARCH =================

    const filteredData = data.filter(item =>
        JSON.stringify(item)
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    return (
        <Box
            sx={{
                p: 1,
                bgcolor: "#f4f6f8",
                minHeight: "100vh",

                "& .MuiTableCell-root": {
                    fontSize: 12,
                    py: 0.7
                },

                "& .MuiInputBase-root": {
                    fontSize: 13
                }
            }}
        >

            <Paper sx={{ p: 2 }}>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    mb={2}
                >

                    <Typography variant="h6">
                        Refferance Details
                    </Typography>

                    <Box display="flex" gap={1}>

                        <TextField
                            size="small"
                            label="Search"
                            value={search}
                            onChange={(e) =>
                                setSearch(e.target.value)
                            }
                        />

                        <Button
                            variant="contained"
                            onClick={() => {
                                setEditId(null);
                                setOpen(true);
                            }}
                        >
                            Add
                        </Button>

                    </Box>

                </Box>

                <TableContainer>

                    <Table size="small">

                        <TableHead>

                            <TableRow>

                                <TableCell>SR</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Mobile</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Joining Date</TableCell>
                                <TableCell align="center">
                                    Action
                                </TableCell>

                            </TableRow>

                        </TableHead>

                        <TableBody>

                            {filteredData
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (

                                    <TableRow key={row.id}>

                                        <TableCell>
                                            {page * rowsPerPage + index + 1}
                                        </TableCell>

                                        <TableCell>
                                            {row.name}
                                        </TableCell>

                                        <TableCell>
                                            {row.mobile}
                                        </TableCell>

                                        <TableCell>
                                            {row.address}
                                        </TableCell>

                                        <TableCell>
                                            {row.joiningDate}
                                        </TableCell>

                                        <TableCell align="center">

                                            <IconButton
                                                color="primary"
                                                size="small"
                                                onClick={() =>
                                                    handleEdit(row)
                                                }
                                            >
                                                <EditIcon fontSize="small" />
                                            </IconButton>

                                            <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() =>
                                                    handleDelete(row.id)
                                                }
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))}

                        </TableBody>

                    </Table>

                </TableContainer>

                <TablePagination
                    component="div"
                    count={filteredData.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[25, 50, 100]}
                    onPageChange={(e, newPage) =>
                        setPage(newPage)
                    }
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(
                            parseInt(e.target.value, 10)
                        );
                        setPage(0);
                    }}
                />

            </Paper>

            {/* ================= DIALOG ================= */}

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >

                <DialogTitle>
                    {editId ? "Update" : "Add"} Through Detail
                </DialogTitle>

                <DialogContent>

                    <TextField
                        fullWidth
                        margin="dense"
                        label="Name"
                        value={formData.name}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                name: e.target.value
                            })
                        }
                    />

                    <TextField
                        fullWidth
                        margin="dense"
                        label="Mobile"
                        value={formData.mobile}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                mobile: e.target.value
                            })
                        }
                    />

                    <TextField
                        fullWidth
                        margin="dense"
                        label="Address"
                        multiline
                        rows={2}
                        value={formData.address}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                address: e.target.value
                            })
                        }
                    />

                    <TextField
                        fullWidth
                        margin="dense"
                        type="date"
                        label="Joining Date"
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={formData.joiningDate}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                joiningDate: e.target.value
                            })
                        }
                    />

                </DialogContent>

                <DialogActions>

                    <Button onClick={handleClose}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSave}
                    >
                        {editId ? "Update" : "Save"}
                    </Button>

                </DialogActions>

            </Dialog>

        </Box>
    );
}

export default Rfferancedetails ;